import { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import useShareRequestNotifications from 'hooks/useShareRequestNotifications';

export default function NotificationListener({ token, userGuid }) {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);
  const openTarget = useCallback(target => navigateRef.current(target), []);
  useShareRequestNotifications(token, userGuid, openTarget);
  return null;
}
NotificationListener.propTypes = {
  token: PropTypes.string,
  userGuid: PropTypes.string
};
